@import './ui-cms-stock-indices';

sd-spinner {
  margin-left: 50%;
}

sd-spinner ~ .dax-box-wrapper__header {
  display: none;
}
